import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
      const token = localStorage.getItem('jwtToken');
      return {
        headers: new HttpHeaders({
          'Authorization' : `Bearer ${token}`
        })
      }
    }

  getAppointment(fromOrParams?: string | any, to?: string, compact?: boolean) {
    let params: any = {};

    if (fromOrParams && typeof fromOrParams === 'object') {
      params = { ...fromOrParams };
    } else {
      if (fromOrParams) params.from = fromOrParams;
      if (to) params.to = to;
      if (compact) params.compact = 1;
    }

    return this.http.get(
      this.apiUrl + '/appointment', { params, ...this.getAuthHeaders()}, 
    );
  }

  addAppointment(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addAppointment";
    // return this.http.post(this.common.getBaseUrl() + 'Appointment.php', payload);
    return this.http.post(this.apiUrl + '/appointment', payload, this.getAuthHeaders());
  }

  updateAppointment(payload: any) {
    payload["action"] = "updateAppointment";
    // return this.http.put(this.common.getBaseUrl() + 'Appointment.php', payload);
    return this.http.put(this.apiUrl + '/appointment/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteAppointment(payload: any) {
    payload["action"] = "deleteAppointment";
    return this.http.put(this.common.getBaseUrl() + 'Appointment.php', payload);
  }

  searchPatients(query: string) {
    return this.http.get(this.apiUrl + '/patient/search', { params: { q: query }, ...this.getAuthHeaders() });
  }

  getAllQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/all', payload, this.getAuthHeaders());
  }

  getQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue', payload, this.getAuthHeaders());
  }

  getMedicineQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/medicine', payload, this.getAuthHeaders());
  }

  getOnlyMedicineQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/medicine/only', payload, this.getAuthHeaders());
  }

  getAllMedicineQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/medicine/all', payload, this.getAuthHeaders());
  }

  getScheduledLaterMedicineQueue(payload: any) {
    return this.http.post(this.apiUrl + '/queue/schedule', payload, this.getAuthHeaders());
  }

  getAppointmentDetails(id: number) {
    return this.http.get(this.apiUrl + '/appointment/' + id, this.getAuthHeaders());
  }

  getDateWisePrescription(payload: any) {
    return this.http.post(this.apiUrl + '/queue/medicine/date-wise', payload, this.getAuthHeaders());
  }

  // changeStatus(id: number, status: string) {
  //   return this.http.post(this.apiUrl + '/appointment/' + id + '/status', { status }, this.getAuthHeaders());
  // }

  // changeStatus(id: number, status: string, prescription_id?: number, follow_up_date?: string) {
  //   const payload: any = { status };

  //   if (prescription_id) {
  //     payload.prescription_id = prescription_id;
  //   }

  //   if (follow_up_date) {
  //     payload.follow_up_date = follow_up_date;
  //   }

  //   return this.http.post(
  //     `${this.apiUrl}/appointment/${id}/status`,
  //     payload,
  //     this.getAuthHeaders()
  //   );
  // }

  // changeStatus(id: number, payload: any) {
  //   return this.http.post(
  //     `${this.apiUrl}/appointment/${id}/status`,
  //     payload,
  //     this.getAuthHeaders()
  //   );
  // }

  changeStatus(id: number, payload: any) {

    const body: any = {};

    if (payload.status) {
      body.status = payload.status;
    }

    if (payload.prescription_id) {
      body.prescription_id = payload.prescription_id;
    }

    if (payload.follow_up_date) {
      body.follow_up_date = payload.follow_up_date;
    }

    return this.http.post(
      `${this.apiUrl}/appointment/${id}/status`,
      body,
      this.getAuthHeaders()
    );
  }
}
